import React from 'react';
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from '../../../assets/image/image-page-banner.webp';
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionAnnoucements from "../../../components/sections/front/Annoucements/SectionAnnoucements";

const AnnoucementList = () => {
  return (
    <>
      <PageBanner title={"Updates"} image={BannerImage} />
      <SectionAnnoucements/>
      <OurPartners />
    </>
  );
};

export default AnnoucementList;